export const environment = {
  production: false,
  showDevInfo: true,
};
